(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bpc-accessibility-tools"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bpc-a11y').forEach((widget) => {
    if (widget.dataset.initialized === 'true') return;
    widget.dataset.initialized = 'true';

    const root = document.documentElement;
    const storageKey = 'bpc-accessibility-preferences';
    const controls = Array.from(widget.querySelectorAll('[data-a11y-pref]'));
    const status = widget.querySelector('[data-a11y-status]');
    const launchButton = widget.querySelector('[data-a11y-v2-launch]');
    const panel = widget.querySelector('.bpc-a11y__panel');
    const classFor = (preference) => `bpc-a11y-${preference}`;
    let preferences = {};

    try {
      preferences = JSON.parse(localStorage.getItem(storageKey) || '{}');
    } catch (error) {
      preferences = {};
    }

    const announce = (message) => {
      if (status) status.textContent = message;
    };

    launchButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      panel.togglePopover();
    }, true);

    const apply = () => {
      controls.forEach((control) => {
        const preference = control.dataset.a11yPref;
        const active = preferences[preference] === true;
        root.classList.toggle(classFor(preference), active);
        control.setAttribute('aria-pressed', String(active));
      });
      localStorage.setItem(storageKey, JSON.stringify(preferences));
    };

    controls.forEach((control) => {
      control.addEventListener('click', () => {
        const preference = control.dataset.a11yPref;
        preferences[preference] = preferences[preference] !== true;
        apply();
        announce(`${control.textContent.trim()} ${preferences[preference] ? 'on' : 'off'}`);
      });
    });

    widget.querySelector('[data-a11y-reset]')?.addEventListener('click', () => {
      preferences = {};
      apply();
      announce('Accessibility preferences reset');
    });

    apply();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bpc-email-popup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bpc-email-popup]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const dialog = root.querySelector('dialog');
    const email = root.querySelector('input[type="email"]');
    const success = root.querySelector('[data-popup-success]');
    const storageKey = `bpc-email-popup-${root.dataset.popupId}`;
    const frequencyMs = Number(root.dataset.frequency) * 86400000;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const lastDismissed = Number(localStorage.getItem(storageKey) || 0);
    const recentlyDismissed = Date.now() - lastDismissed < frequencyMs;
    const excludedPage = root.dataset.pageType === 'cart' || root.dataset.pageType === 'search';

    const closePopup = () => {
      localStorage.setItem(storageKey, String(Date.now()));
      if (dialog.open) dialog.close();
    };

    root.querySelectorAll('[data-popup-close]').forEach((button) => button.addEventListener('click', closePopup));
    root.querySelectorAll('[data-popup-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const code = button.dataset.code;
        try {
          await navigator.clipboard.writeText(code);
          button.textContent = button.dataset.copiedLabel;
          window.setTimeout(() => { button.textContent = button.dataset.copyLabel; }, 1800);
        } catch (error) {
          const codeElement = root.querySelector('[data-popup-code]');
          if (codeElement) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(codeElement);
            selection.removeAllRanges();
            selection.addRange(range);
          }
        }
      });
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closePopup();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup();
    });

    if (success) {
      localStorage.setItem(storageKey, String(Date.now()));
      dialog.showModal();
      success.focus();
      return;
    }

    if (Shopify.designMode) {
      dialog.showModal();
      return;
    }

    if (excludedPage || recentlyDismissed || isMobile && root.dataset.showMobile !== 'true') return;

    window.setTimeout(() => {
      if (!dialog.open) {
        dialog.showModal();
        if (email) email.focus();
      }
    }, Number(root.dataset.delay));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
